export const BASE_URL = 'https://cenojad.pl';

export const MAX_INT_CONST = 2147483647;
